import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/node_modules/@mui/icons-material/esm/EmojiEventsOutlined.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/node_modules/@mui/icons-material/esm/TrendingUp.js");
;
import(/* webpackMode: "eager" */ "/home/nawar/dev/app/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/home/nawar/dev/app/node_modules/@mui/material/Stack/index.js");
;
import(/* webpackMode: "eager" */ "/home/nawar/dev/app/node_modules/@mui/material/Typography/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/component/AppBar/bars/Discover.js");
;
import(/* webpackMode: "eager", webpackExports: ["PaperCardSize3"] */ "/home/nawar/dev/app/src/component/Card/Paper.js");
;
import(/* webpackMode: "eager", webpackExports: ["CardProductSize2"] */ "/home/nawar/dev/app/src/component/Card/Product.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/view/discover/Content/Customize/Tasks/Following.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/view/discover/Content/Customize/Tasks/Trending/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/view/discover/Content/Following/index.js");
;
import(/* webpackMode: "eager" */ "/home/nawar/dev/app/src/view/discover/Content/Trending/Masonry.js");
